import gtm from "./scripts/gtm";
import wpcf7Structure from "./scripts/wpcf7-structure";
import { extendJquery,validateEmail } from "./scripts/utils";
import skipLinkFocusFix from "./scripts/skip-link-focus-fix";
import  popup from "./scripts/popup";
import navigation from "./scripts/navigation";
import setupAnimations from "./scripts/animations";
import ready from "./scripts/ready";

ready(()=>{
    setupAnimations();
    popup();
})

skipLinkFocusFix();
extendJquery();
wpcf7Structure();
gtm.listen();
navigation();



(function($){
    
    ready(()=>{
         // parallax des bannières
         $('.with-parallax').each(function(){
            $(this).children('img').parallax($(this),4,0);
        });
        // parallax de la bannière générale
        // if($('.banner-parallax').length){
        //     $('.banner-parallax img').parallax($('.banner'),4,0);
        // }
        $( window ).on( "resize", function() {
            $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
        } );
        $('body').css('--wp--custom--height-nav', $('#masthead').height()+"px");
    });


    /* inscription a l'infolettre */
    $('.infolettre, .newsletter-form').submit(function(e){
        e.preventDefault();
        var messageLog = $(this).find('.message-form');

        if(!validateEmail($(this).find('input[name="email"]').val())){
            messageLog.removeClass('success').addClass('error').find('span').text(siteData.traduction.emailError);
        }else{
            if($(this).find('input[name="fullname"]').val() == ""){
                messageLog.removeClass('success').addClass('error').find('span').text('Le nom est obligatoire.');
                return;
            }
            // update user interface
            messageLog.removeClass('success error').find('span').html(siteData.traduction.emailProcessing);
            var data = {
                email: $(this).find('input[name="email"]').val(),
                lang: siteData.lang,
                fullname: $(this).find('input[name="fullname"]').val()
            }

            wp.apiFetch({
                path: "codems/newsletter/subscription",
                method: 'POST',
                data: data
            }).then( res => {

                if(res.success){			
                    messageLog.removeClass('error').addClass('success').find('span').html(res.message);
                    $(this).find('input[name="email"]').val('');
                    $(this).find('input[name="fullname"]').val('');
                    dataLayer.push({'event': 'newsletter'});
                }else{
                    messageLog.removeClass('success').addClass('error').find('span').html(res.message);
                }
            })
            
            return false;
        }
    });

    if($(window).width() <= 1024 && $('.blog-wrapper').length){
        $('.blog-wrapper .sidebar .sidebar-title').click(function(){
            $(this).siblings('ul').slideToggle();
        });
    }

    //menu sticky on scroll up
	var previousScrollTop = 0;

    $(document).scroll(function() {
		var y = $(this).scrollTop();
        var heightToSticky = $('.site-header').height();

		if(!$('body').hasClass('menu-open')){

            if(y > heightToSticky){
                // retire la nav au scroll down et la fait apparaitre on scroll up
                if(y > previousScrollTop){
                    $('body').addClass('hide-nav'); 
                }else{
                    $('body').removeClass('hide-nav');
                }
            }   
		}		
		previousScrollTop = y;

	});

    $(document).ready(function(){
        if($('.wpcf7-form').length){
            $('input,textarea').on('focus', function() {

                $(this).parent().addClass('move');
            })
            
            $('input,textarea').on('focusout', function() {

                if(!$(this).val()) $(this).parent().removeClass('move');
            })
        }

        if($('.swap-color').length){
           // Sélectionnez l'élément
            const swapColor = document.querySelector('.swap-color');

            // Vérifiez si l'élément existe
            if (swapColor) {
                // Créez un observateur avec une marge spécifique
                // Function to check if the browser is Safari
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

                // Set rootMargin based on the browser
                const rootMarginValue = isSafari ? '0px' : '-40% 0px -100% 0px';

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (isSafari) {
                                // Add a 2-second delay for Safari
                                setTimeout(() => {
                                    swapColor.classList.add('change-color');

                                }, 2000); // Delay of 2 seconds
                            } else {
                                // Immediately add the class for other browsers
                                swapColor.classList.add('change-color');
 
                            }
                        } else {
                            // Remove the class when the element is out of the threshold
                            swapColor.classList.remove('change-color');
       
                        }
                    });
                }, {
                    rootMargin: rootMarginValue // Use dynamic rootMargin value
                });

                // Observe the element
                observer.observe(swapColor);
    

                // Observez l'élément
                observer.observe(swapColor);
            }
        }
    });



    // le bloc faq de yoast
    $('.schema-faq-question').click(function(){
        $(this).parent().toggleClass('open').find('.schema-faq-answer').slideToggle();
    });

    // anime les chiffres
	if($('.animate-counter').length){
		$(window).on('scroll load', function() {
			$('.animate-counter strong').each(function () {
				if(!$(this).hasClass('animated')){
					if($(this).isOnScreen() == true){
						var number = $(this).text();
						var initNumber = number;

						if($('body').hasClass('lang_fr') && $(this).hasClass('decimal-number')){
							number = number.replace(',','.')
						}
						$(this).prop('Counter',0).animate({
							Counter: number
						}, {
							duration: 3000,
							easing: 'swing',
							step: function () {
								if($('body').hasClass('lang_fr') && $(this).hasClass('decimal-number')){
									number = this.Counter.toFixed('2');
									number = number.replace('.',',');
								}else{
									number = Math.ceil(this.Counter);
								}
								$(this).text(number);
								$(this).addClass("animated");
							},
							complete: function(){
								$(this).text(initNumber);
							}
						});


					}
				}
			});
		});
	}

})(jQuery);